// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__2K0sZ","detailOffset":"style_detailOffset__1DXel"};